function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createElementObject, createTileLayerComponent, updateGridLayer, withPane } from "@manifesto-tech/react-leaflet-core";
import { TileLayer } from "leaflet";
export var WMSTileLayer = createTileLayerComponent(function createWMSTileLayer(_param, context) {
    var _eh = _param.eventHandlers, _param_params = _param.params, params = _param_params === void 0 ? {} : _param_params, url = _param.url, options = _objectWithoutProperties(_param, [
        "eventHandlers",
        "params",
        "url"
    ]);
    var layer = new TileLayer.WMS(url, _objectSpread({}, params, withPane(options, context)));
    return createElementObject(layer, context);
}, function updateWMSTileLayer(layer, props, prevProps) {
    updateGridLayer(layer, props, prevProps);
    if (props.params != null && props.params !== prevProps.params) {
        layer.setParams(props.params);
    }
});
